export default __webpack_public_path__ + "static/media/meal.e0866d1e.png";